var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.285,
    height: 55.318,
    viewBox: "0 0 55.285 55.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegram",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27153",
    "data-name": "Path 27153",
    d: "M27.609,0C11.541.269-.023,12.787,0,27.64A27.35,27.35,0,0,0,27.6,55.318,27.4,27.4,0,0,0,55.285,27.606,27.639,27.639,0,0,0,27.609,0ZM40.991,19.735q-2.176,10.3-4.378,20.589a4.25,4.25,0,0,1-.318.964,1.106,1.106,0,0,1-1.412.654,3.156,3.156,0,0,1-1.015-.466c-2.079-1.52-4.142-3.063-6.208-4.6-.146-.108-.295-.213-.469-.338-1.061,1.025-2.094,2.02-3.122,3.019a2.393,2.393,0,0,1-1.628.815c.013-.167.028-.328.041-.49.154-2.035.313-4.068.456-6.105a1.048,1.048,0,0,1,.367-.748Q29.488,27.4,35.657,21.755c.008-.008.021-.013.026-.023.095-.177.19-.356.282-.536-.228-.008-.507-.108-.677-.013-.72.4-1.412.856-2.109,1.294q-5.29,3.329-10.578,6.656c-1.066.674-2.138,1.343-3.2,2.022a.658.658,0,0,1-.607.082c-2.263-.7-4.529-1.381-6.792-2.073a1.912,1.912,0,0,1-.492-.228.582.582,0,0,1-.2-.9,2.9,2.9,0,0,1,.987-.759c1.023-.449,2.071-.833,3.114-1.235l18.856-7.274q2.4-.927,4.793-1.845a3.944,3.944,0,0,1,.413-.146,1.29,1.29,0,0,1,1.745,1.241A7.745,7.745,0,0,1,40.991,19.735Z",
    transform: "translate(0 0)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.3b435ef29854376f1d145c386effb343.svg";
export { ForwardRef as ReactComponent };